import Footer from "../Sub/Footer";
import webBanner from "../../images/webBanner.png";
import CommonHeader from "../Sub/CommonHeader";
import Banner from "../Sub/Banner";
import { Row } from "react-bootstrap";

const About = () => {
  let width = window.innerWidth;
  return (
    <>
      <CommonHeader />
      <div>
        <Banner bannerImg={webBanner} />
      </div>
      <div className="container-fluid">
        <div className={`page-main ${width >= 468 && "p-5"}`}>
          <Row>
            <h1 className="mb-4">ABOUT US</h1>
            <p>
              Our company (<b>DAYAL ENTERPRISES</b>)
            </p>
            {/* <div className="border-y mb-4">
              <h2 className="mb-0">
                Lorem ipsum <span>dolor sit amet</span>, consectetur adipiscing
                elit. Nunc hendrerit tellus et nisi ultra trices, eu feugiat
                sapien commodo. Praesent vitae ipsum et risus.
              </h2>
            </div> */}
            <p>Broadly we are working in following items.</p>
            <p className="mb-0">1. Phone Cover</p>
            <p className="mb-0">2. Headphones</p>
            <p className="mb-0">3. Earphone etc.</p>
            <p>
              We have more than <b>500</b> different products available.
            </p>
            <p>
              We are supplying material in <b>PAN INDIA</b>
            </p>
            <p>
              With this website we want to give <b>minimum</b> price
              directly/indirectly to our dealers.
            </p>
            <p>
              DAYAL ENTERPRISES
              <br /><br/>
              <b>Building No./Flat No.</b>: RAIGARO KA MOHALLA<br/>
              <b>Road/Street</b>: AJMER ROAD<br/>
              <b>Locality/Sub Locality</b>: KESHOPURA<br/>
              <b>City/Town/Village</b>: Jaipur<br/>
              <b>District</b>: Jaipur<br/>
              <b>State</b>: Rajasthan<br/>
              <b>PIN Code</b>: 302021
              
              <br /><br/>
              TEL. NO.:63677-22194
              <br />
              Email: support@dayalenterprises.com
            </p>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
